import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import {
  REDUCER_NAME,
  RESET_PLAYERHISTORY,
  SET_ERROR,
  SET_PLAYERHISTORY,
} from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  history: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PLAYERHISTORY:
      return {
        ...state,
        isReady: true,
        isError: false,
        history: action.data,
      };
    case RESET_PLAYERHISTORY:
      return initialState;
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (n) => n.isReady);

export const selectIsError = createSelector(getState, (n) => n.isError);

export const selectPlayerHistory = createSelector(getState, (n) => n.history);

reducerRegistry.register(REDUCER_NAME, reducer);
